function setcookie(name, value, expires, path, domain, secure) { // Send a cookie
    //
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

    expires instanceof Date ? expires = expires.toGMTString() : typeof(expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
    var r = [name + "=" + escape(value)],
        s, i;
    for (i in s = { expires: expires, path: path, domain: domain }) {
        s[i] && r.push(i + "=" + s[i]);
    }
    return secure && r.push("secure"), document.cookie = r.join(";"), true;
}

// возвращает cookie если есть или undefined
function getcookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
}

function setHeaderPadding() {
    var headerTopHeight = $(".header__top").outerHeight();

    $(".header-index").css("padding-top", headerTopHeight);
    $(".header-inner").css("padding-top", headerTopHeight);
};

$('.alert__close').click(function() {
    $('.alert').slideUp();
    setcookie('alert_closed', 1, 48 * 60 * 60, '/');
    setHeaderPadding();
});
